<template>
  <v-dialog persistent v-model="dialog" width="640px">
    <template v-slot:activator="{ on, attrs }">
      <slot name="button" :activator="{ on, attrs }" />
    </template>
    <div class="container">
      <ACLEditor
        :document="document"
        :on-prepared-analysis="onPreparedAnalysis"
        :is-in-personal-portfolio="isInPersonalPortfolio"
        ref="aclEditor"
        @saved="onSave"
        @close="close"
        @cancel="close"
      />
    </div>
  </v-dialog>
</template>
<script>
import ACLEditor from './ACLEditor';

export default {
  name: 'ACLModal',
  components: {
    ACLEditor,
  },
  data: () => ({
    dialog: false,
  }),
  props: {
    document: {
      type: Object,
      required: true,
    },
    onPreparedAnalysis: {
      type: Boolean,
      default: false,
    },
    isInPersonalPortfolio: {
      type: Boolean,
      default: undefined,
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit('close');
    },
    onSave(payload) {
      this.$emit('save', payload);
    },
    saveAcl() {
      this.$refs.aclEditor.startSaveProcess();
    },
  },
};
</script>
<style scoped>
.container {
  background-color: white;
  padding: 12px;
}
</style>
